// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"780":"9a2c3374","938":"fc35eacf"}[chunkId] + ".chunk.js";
};